function DangerBlocks() {
  return (
    <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.873 38.2814L1.13859 22.3933C0.598008 22.1656 0 22.5626 0 23.1493V65.6249C0 66.6982 0.653461 67.6636 1.65014 68.0621L38.25 82.702C38.7888 82.9176 39.375 82.5207 39.375 81.9404V39.0374C39.375 38.7075 39.1771 38.4096 38.873 38.2814Z"
        fill="#EB5757"
      />
      <path
        d="M42.3182 33.7678L78.7917 18.4106C79.4473 18.1346 79.4649 17.2119 78.8203 16.9112L43.1099 0.246217C42.4063 -0.0820723 41.5935 -0.0820723 40.8898 0.246217L5.17951 16.911C4.53491 17.2118 4.55246 18.1344 5.20805 18.4104L41.6816 33.7676C41.885 33.8534 42.1147 33.8534 42.3182 33.7678Z"
        fill="#EB5757"
      />
      <path
        d="M65.625 41.9999C72.5665 41.9999 78.8174 45.0101 83.1434 49.7927C83.4458 50.1271 84 49.9146 84 49.4639V23.1493C84 22.5626 83.402 22.1656 82.8614 22.3933L45.127 38.2814C44.8229 38.4096 44.625 38.7073 44.625 39.0374V52.949C44.625 53.4441 45.273 53.6287 45.5339 53.208C49.7034 46.486 57.1499 41.9999 65.625 41.9999Z"
        fill="#EB5757"
      />
      <path
        d="M65.625 47.25C55.493 47.25 47.25 55.493 47.25 65.625C47.25 75.757 55.493 84 65.625 84C75.757 84 84 75.757 84 65.625C84 55.493 75.757 47.25 65.625 47.25ZM71.4185 67.7063C72.4438 68.7315 72.4438 70.3935 71.4185 71.4187C70.906 71.9312 70.2343 72.1875 69.5625 72.1875C68.8907 72.1875 68.219 71.9312 67.7065 71.4187L65.625 69.3372L63.5435 71.4187C63.031 71.9312 62.3593 72.1875 61.6875 72.1875C61.0157 72.1875 60.344 71.9312 59.8315 71.4187C58.8062 70.3935 58.8062 68.7315 59.8315 67.7063L61.9128 65.625L59.8315 63.5437C58.8062 62.5185 58.8062 60.8565 59.8315 59.8313C60.8565 58.8062 62.5186 58.8062 63.5437 59.8313L65.625 61.9126L67.7065 59.8311C68.7315 58.8061 70.3936 58.8061 71.4187 59.8311C72.4439 60.8564 72.4439 62.5183 71.4187 63.5435L69.3372 65.625L71.4185 67.7063Z"
        fill="#EB5757"
      />
    </svg>
  );
}

export default DangerBlocks;
